import {
  TMobileDrawerProps,
  MobileDrawer as UiKitMobileDrawer,
} from '@landlord-tech/ui-kit-opp';
import styled from 'styled-components';
import {
  Modal as UIKitModal,
  ModalDeleteConfirmation as UIKitModalDeleteConfirmation,
} from '@landlord-tech/ui-kit-opp/dist/components/Modal';

import { TModalDeleteProps, TModalProps } from './Modal.types';

export const SModal = styled(UIKitModal)<TModalProps>`
  &&& {
  }
`;

export const SModalDeleteConfirmation = styled(
  UIKitModalDeleteConfirmation,
)<TModalDeleteProps>`
  &&& {
  }
`;

export const SMobileDrawer = styled(UiKitMobileDrawer)<TMobileDrawerProps>`
  &&& {
  }
`;
